export default __webpack_public_path__ + "static/careers-mission-globe-sphere-1fccc461e38cee0d6ea1b889b19351b8.png";